import { useWeb3React } from '@web3-react/core'
import useTranslation from 'next-translate/useTranslation'
import { useContext } from 'react'

import { useShowUserBalances } from '../hooks/useShowUserBalances'
import { useWalletChainId } from '../hooks/useWalletChainId'
import { useWalletScreening } from '../hooks/useWalletScreening'

import Button from './Button'
import { MetronomeContext } from './MetronomeContext'

const OperationButton = function ({
  children = '',
  className = '',
  disabled = false,
  id = '',
  onClick = () => false,
  ...props
}) {
  const { bannedWallets, isWalletApproved } = useWalletScreening()
  const chainId = useWalletChainId()
  const { account } = useWeb3React()
  const { t } = useTranslation('common')
  const showUserBalances = useShowUserBalances()
  const { disableOnOperation } = useContext(MetronomeContext)

  const walletBanned =
    bannedWallets[chainId] && bannedWallets[chainId].includes(account)
  const approveWalletAndContinue = () =>
    isWalletApproved(account, chainId).then(function (isApproved) {
      if (isApproved) {
        return onClick()
      }
      return null
    })

  const button = (
    <Button
      aria-describedby={id}
      className={`h-12 w-full ${className ? className : ''}`}
      data-sentry="operation-submit"
      disabled={
        walletBanned || !showUserBalances || disableOnOperation || disabled
      }
      id={id}
      onClick={approveWalletAndContinue}
      size="lg"
      {...props}
    >
      {children}
    </Button>
  )
  return (
    <div>
      {button}
      {walletBanned && (
        <div className="bg-red-02 mt-4 px-6 py-3 text-center text-sm text-gray-300">
          {walletBanned && t('wallet-banned-message')}
        </div>
      )}
    </div>
  )
}

export default OperationButton
